import React from 'react';
import { Step } from 'react-joyride';

import Link from 'buyside/components/presentation/Link/link';

import { quickPositionsPageUrl } from 'buyside/util/urlHelper';

export enum IdeaShowJoyrideTarget {
  CREATE_QUICK_POSITION = 'joyrideTargetCreateQuickPosition'
}

export const ideaShowJoyrideSteps: { createQuickPosition: Step } = {
  createQuickPosition: {
    title: 'Quick Positions',
    target: `[data-joyride-target="${IdeaShowJoyrideTarget.CREATE_QUICK_POSITION}"]`,
    placement: 'auto',
    content: (
      <>
        Build your position portfolio and track the return performance through your{' '}
        {<Link to={quickPositionsPageUrl()}>quick positions dashboard</Link>}. Once you take a
        position, you will be able to see the community sentiment on the security.
      </>
    ),
    disableBeacon: true
  }
};
